export type HeapUserProperties = Record<string, string | number | boolean>;

export const useHeap = () => {
  const isHeapAvailable = typeof window !== 'undefined' && (window as any).heap;

  const identifyUser = (
    userId: string | number | undefined,
    properties?: HeapUserProperties,
  ) => {
    if (!isHeapAvailable || !userId) {
      return;
    }

    try {
      (window as any).heap.identify(userId);

      if (properties && Object.keys(properties).length) {
        (window as any).heap.addUserProperties(properties);
      }
    } catch (err) {

      console.error('Heap identify error', err);
    }
  };

  const trackEvent = (
    eventName: string,
    properties?: Record<string, unknown>,
  ) => {
    if (!isHeapAvailable) {
      return;
    }

    try {
      (window as any).heap.track(eventName, properties);
    } catch (err) {

      console.error('Heap track error', err);
    }
  };

  const trackLoggedIn = () => trackEvent('Logged In');
  const trackSignedUp = () => trackEvent('Signed Up');

  return {
    identifyUser,
    trackEvent,
    trackLoggedIn,
    trackSignedUp,
  };
};
